/**
 * IG (Intelligems) app integration — runs alongside native GWP.
 * - restart() on theme cart changes (add / update / remove), debounced
 * - restart() on Fondue internal cart updates
 * - restart() when the cart drawer opens (only if cart changed since last restart)
 * - refresh theme cart when the app fires ig:CartUpdated (suppress duplicate restarts)
 */
// @ts-nocheck
(() => {
  const LOG = "[IG GWP]";
  const DEBOUNCE_MS = 150;

  let restartTimer = null;
  let suppressCartUpdate = false;
  let lastRestartCartToken = null;
  let cartTokenFallback = 0;

  /** @returns {string} */
  function getCartToken() {
    const drawer = document.querySelector("cart-drawer-component");
    if (drawer?.dataset?.cartToken) {
      return drawer.dataset.cartToken;
    }

    const BWW = /** @type {any} */ (window).BWW;
    const cart = BWW?.getCart?.() ?? BWW?.state?.cartState;
    if (cart) {
      const items = (cart.items || []).map(item => `${item.variant_id}:${item.quantity}`).join(",");
      return `${cart.item_count}|${cart.total_price}|${items}`;
    }

    cartTokenFallback += 1;
    return `fallback-${cartTokenFallback}`;
  }

  /** @returns {boolean} */
  function runIgRestart() {
    const ig = /** @type {any} */ (window).igData;
    if (!ig || typeof ig.restart !== "function") return false;
    try {
      ig.restart();
      lastRestartCartToken = getCartToken();
      return true;
    } catch (error) {
      console.error(LOG, "restart failed", error);
      return false;
    }
  }

  function igRestart() {
    clearTimeout(restartTimer);
    restartTimer = setTimeout(runIgRestart, DEBOUNCE_MS);
  }

  function onCartUpdateRestart() {
    if (suppressCartUpdate) return;
    igRestart();
  }

  function onDialogOpenRestart() {
    const token = getCartToken();
    if (token === lastRestartCartToken) return;
    igRestart();
  }

  /** Sync cart DOM/state after the IG app mutates the cart (same path as BWW cart:update handler). */
  async function refreshCart() {
    const BWW = /** @type {any} */ (window).BWW;
    if (!BWW?.ready) return;

    await new Promise(resolve => {
      BWW.ready(async state => {
        try {
          await state.shopify().updateCart();
        } catch (error) {
          console.error(LOG, "cart refresh failed", error);
        }
        resolve();
      });
    });
  }

  function bindCartDrawerOpen() {
    const drawer = document.querySelector("cart-drawer-component");
    if (!drawer || drawer.dataset.igOpenBound === "true") return;

    drawer.dataset.igOpenBound = "true";
    drawer.addEventListener("dialog:open", onDialogOpenRestart);
  }

  function init() {
    document.addEventListener("cart:update", onCartUpdateRestart);
    document.addEventListener("fondue:internal:cart.updated", igRestart);

    window.addEventListener("ig:CartUpdated", async () => {
      suppressCartUpdate = true;
      try {
        await refreshCart();
      } finally {
        suppressCartUpdate = false;
      }
    });

    bindCartDrawerOpen();
    document.addEventListener("section:morph", bindCartDrawerOpen);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
